import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useMaestroTarjetasStore = defineStore('maestroTarjetas', {
  state: () => ({
    maestroTarjetas: [],
    search: '',
    perPage: 20,
    page: 1,
    currentPage: 1,
    totalMaestroTarjetas: 0,
    totalPages: 1
  }),
  actions: {
    async fetchMaestroTarjetas({ page, rows, search, perPage } = {}) {
      try {
        const response = await api.get('/maestro-tarjetas', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            page: page || this.page,
            rows: rows || this.rows,
            search: search || this.search,
            per_page: perPage || this.perPage
          }
        })
        this.maestroTarjetas = response.data.items
        this.totalMaestroTarjetas = response.data.total
        this.totalPages = response.data.pages
        this.perPage = response.data.per_page
        this.page = response.data.page
        console.log('this.maestroTarjetas', this.maestroTarjetas)
        return this.maestroTarjetas
      } catch (error) {
        console.error('Error al obtener maestro tarjetas:', error)
        throw error
      }
    },
    async createMaestroTarjeta(maestroTarjeta) {
      try {
        const response = await api.post('/maestro-tarjetas', maestroTarjeta, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.maestroTarjetas.push(response.data)
        return response.data
      } catch (error) {
        console.error('Error al crear maestro tarjeta:', error)
        throw error
      }
    },
    async updateMaestroTarjeta(maestroTarjeta) {
      try {
        const response = await api.put(
          `/maestro-tarjetas/${maestroTarjeta.id}`,
          maestroTarjeta,
          {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          }
        )
        const index = this.maestroTarjetas.findIndex(
          (mt) => mt.id === maestroTarjeta.id
        )
        if (index !== -1) {
          this.maestroTarjetas[index] = response.data
        }
        return response.data
      } catch (error) {
        console.error('Error al actualizar maestro tarjeta:', error)
        throw error
      }
    },
    async deleteMaestroTarjeta(id) {
      try {
        await api.delete(`/maestro-tarjetas/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.maestroTarjetas = this.maestroTarjetas.filter((mt) => mt.id !== id)
      } catch (error) {
        console.error('Error al eliminar maestro tarjeta:', error)
        throw error
      }
    },
    setSearch(search) {
      this.search = search
    },
    setRows(rows) {
      this.rows = rows
    },
    setPage(page) {
      this.page = page
    },
    async getMaestroTarjeta(id) {
      try {
        const response = await api.get(`/maestro-tarjetas/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error al obtener maestro tarjeta:', error)
        throw error
      }
    }
  }
})
